import type { TReturnReason } from "@repo/shopify/api/requestReturn";
import { ReturnReason } from "@repo/shopify/api/requestReturn";
import { t } from "i18next";

export const COLLECTION_SORT = [
  { label: "Recent", value: "COLLECTION_DEFAULT", reverse: false, name: "recent", sortIndex: 0 },
  { label: "Best Selling", value: "BEST_SELLING", reverse: false, name: "best_selling", sortIndex: 1 },
  { label: "Price: High to Low", value: "PRICE", reverse: true, name: "price_descending", sortIndex: 2 },
  { label: "Price: Low to High", value: "PRICE", reverse: false, name: "price_ascending", sortIndex: 3 },
];

export const SEARCH_SORT = [
  { label: "Relevance", value: "RELEVANCE", reverse: false, name: "relevance", sortIndex: 0 },
  { label: "Price: High to Low", value: "PRICE", reverse: true, name: "price_descending", sortIndex: 1 },
  { label: "Price: Low to High", value: "PRICE", reverse: false, name: "price_ascending", sortIndex: 2 },
];

export const VIEW_OPTIONS = [
  { name: "seperate", id: "seperate", value: "seperate", label: "Seperate" },
  { name: "combined", id: "combined", value: "combined", label: "Combined" },
];

export interface ISortOption {
  label: string;
  value: string;
  reverse: boolean;
}

export const SORT: ISortOption[] = [
  { label: "Oldest to Newest", value: "CREATED", reverse: false },
  { label: "Newest to Oldest", value: "CREATED", reverse: true },
];

export const INTL_ASIA_PROVIDER = [
  "ALIPAY",
  "ALIPAYHK",
  "BILLEASE",
  "BOOST",
  "BPI",
  "DANA",
  "GCASH",
  "RABBIT_LINE_PAY",
  "TOUCHNGO",
  "TRUEMONEY",
];

export const translationReturnReason: Partial<Record<TReturnReason, string>> = {
  [ReturnReason.DEFAULT]: t("return_reason.default"),
  [ReturnReason.UNWANTED]: t("return_reason.unwanted"),
  [ReturnReason.DEFECTIVE]: t("return_reason.defective"),
  [ReturnReason.WRONG_ITEM]: t("return_reason.wrong_item"),
  [ReturnReason.SIZE_TOO_LARGE]: t("return_reason.size_large"),
  [ReturnReason.SIZE_TOO_SMALL]: t("return_reason.size_small"),
};

export const RETURN_REASON_OPTIONS: { name: string; value: TReturnReason }[] = [
  { name: "Select Reason", value: ReturnReason.DEFAULT },
  { name: t("return_reason.unwanted"), value: ReturnReason.UNWANTED },
  { name: t("return_reason.defective"), value: ReturnReason.DEFECTIVE },
  { name: t("return_reason.wrong_item"), value: ReturnReason.WRONG_ITEM },
  { name: t("return_reason.size_large"), value: ReturnReason.SIZE_TOO_LARGE },
  { name: t("return_reason.size_small"), value: ReturnReason.SIZE_TOO_SMALL },
];
